var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M5.214 11.519c-.48 0-.948-.155-1.331-.438L.275 8.41a.685.685 0 0 1-.13-.97.724.724 0 0 1 .992-.139l3.607 2.672a.79.79 0 0 0 1.114-.184l5.836-8.545a.724.724 0 0 1 .988-.194.686.686 0 0 1 .198.965l-5.837 8.547a2.213 2.213 0 0 1-1.83.957z"}));
}

Tick.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12"};

module.exports = Tick;

Tick.default = Tick;
